import { render, staticRenderFns } from "./Terms&conditions.vue?vue&type=template&id=2438c2e9&"
import script from "./Terms&conditions.vue?vue&type=script&lang=js&"
export * from "./Terms&conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports